/* jshint esversion: 6, -W097 */
/* globals module */

UtilitySelectorService.$inject = ['$q', '$http', 'GetFetchService', 'ProductApiConsumerService', 'UserApiConsumerService'];
function UtilitySelectorService($q, $http, GetFetchService, ProductApiConsumerService, UserApiConsumerService) {

    var _pub = {};
    var _utilityProviders = {};
    var _utilityProviderPromises = {};
    var _electricalUtility = null;

    /**
     * Fetches a set of utilities for a given zipcode
     * The zipCode is optional, if omitted we try to get the
     * zipcode from the user's ip. e.g. backend geoIp functionality
     *
     * @param {String} [zipCode]
     * @param {Object} [params]
     * @param {Boolean} [force]
     * @returns {$q.promise}
     */
    _pub.fetchUtilityProviders = function(zipCode, force) {
        /*
        Example response from `/utility-provider/`
        [
            {"residential_rate": "13.00", "id": 100776, "title": "Los Angeles Department of Water & Power"},
            {"residential_rate": "16.88", "id": 101070, "title": "Southern California Edison Co"}
        ]
        */
        var url = 'api/1.0/utility-providers/';

        if (zipCode) {
            url = url + zipCode + '/';
        }
        if (!_utilityProviderPromises[zipCode] || force) {
            _utilityProviderPromises[zipCode] = ProductApiConsumerService.get(url)
                .then(function success(response) {
                    _utilityProviders[zipCode] = response.data;
                }, function error(response) {
                    _utilityProviders[zipCode] = [];
                });
        }
        return _utilityProviderPromises[zipCode];
    };

    /**
     * Gets the fetched utility response data
     *
     * @param {String} [zipCode]
     * @param {Object} [params]
     * @param {Boolean} [force]
     * @returns {$q.promise}
     */
    _pub.getUtilityProviders = function(zipCode, force) {
        var deferred = $q.defer();
        if (!_utilityProviders[zipCode] || force) {
            _pub.fetchUtilityProviders(zipCode, force).then(function() {
                deferred.resolve(_utilityProviders[zipCode]);
            });
        } else {
            deferred.resolve(_utilityProviders[zipCode]);
        }
        return deferred.promise;
    };

    /**
     * Set User's electrical utility - api call
     * @param utilityData is an object with values like `electrical_utility_id`
     *        and `postal_code` or `user_set_electrical_rate`.
     * @returns {*}
     */
    _pub.setElectricalUtility = function(utilityData) {
        return UserApiConsumerService.post('api/1.0/user-profile/electrical-utility/', utilityData)
            .then(
                function(response) {
                    _electricalUtility = response.data;
                },
                function(response) {
                    _electricalUtility = null;
                }
            );
    };

    /**
     * Fetches user's utility
     * @returns {*} _electricalUtility data
     */
    _pub.fetchUserUtility = function() {
        var urlOptions = {
            url: 'api/1.0/user-profile/electrical-utility/',
            requestingService: UserApiConsumerService.request
        };
        return GetFetchService.get('user-profile-electrical-utility', urlOptions).then(
            // success
            function(response) {
                response.data.title = response.electrical_utility_title;
                _electricalUtility = response;
            },
            function(response) {
                _electricalUtility = null;
            }
        );
    };

    /**
     * Gets user's utility
     * @returns {*}
     */
    _pub.getElectricalUtility = function () {
        return _electricalUtility;
    };

    return _pub;

}

module.exports = UtilitySelectorService;